import { useContext } from "react";
import Header from "./components/Header";
import { auth } from "./config/firebase";
import { AuthContext } from "./contexts/AuthContext";
import PageLogin from "./pages/PageLogin";
import PagePrivate from "./pages/PagePrivate";

const App = () => {

    const { isLogin } = useContext(AuthContext)


    
    return (
        <div>
            <Header />
            <br /><br /><br /><br /><br />
            
            {isLogin && auth.currentUser ? <PagePrivate /> : <PageLogin />}
        </div>
    )
}

export default App;